(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@dwellsocial/dwellsocial-api", [], factory);
	else if(typeof exports === 'object')
		exports["@dwellsocial/dwellsocial-api"] = factory();
	else
		root["@dwellsocial/dwellsocial-api"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 